import React, { useEffect, useState } from "react"
import { Box, Heading, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react"
import { Layout } from "../../GlobalComponent/Layout/Layout"
import { getDoctors } from "../../Http/Index"
import { ShowAlert } from "../../GlobalComponent/Alerts/Alert"
import { RegistryDoctor } from "./shared.types"
import { Registry } from "./Registry"
import { CreateProfile } from "./CreateProfile"
import { Documents } from "./Documents"
import { Verification } from "./Verification"
// import { DoctorRoster } from "./DoctorRoster" // TODO: enable in next release

export const ManageDoctor: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState(0)
  const [selectedDoctor, setSelectedDoctor] = useState<RegistryDoctor | null>(null)
  const [doctors, setDoctors] = useState<RegistryDoctor[]>([])
  const [loadingDoctors, setLoadingDoctors] = useState(false)

  const fetchDoctors = async () => {
    try {
      setLoadingDoctors(true)
      const { data } = await getDoctors()
      setDoctors(data.data)
    } catch (e: any) {
      ShowAlert("error", e?.response?.data?.message || "Failed to fetch doctors")
    } finally {
      setLoadingDoctors(false)
    }
  }

  useEffect(() => { fetchDoctors() }, [])

  const goToDocuments = (doc: RegistryDoctor) => { setSelectedDoctor(doc); setSelectedTab(2) }
  const goToVerification = (doc: RegistryDoctor) => { setSelectedDoctor(doc); setSelectedTab(3) }

  return (
    <Layout>
      <Box style={{ width: "100%" }}>
        <Tabs index={selectedTab} onChange={setSelectedTab} variant="soft-rounded" colorScheme="green">
          <TabList flexWrap="wrap" gap={1}>
            <Tab>Registry</Tab>
            <Tab>Create Profile</Tab>
            <Tab>Documents</Tab>
            <Tab>Verification</Tab>
            {/* <Tab>Doctor Roster</Tab> */}{/* TODO: enable in next release */}
          </TabList>

          <TabPanels>
            <TabPanel px={0} pt={4}>
              <Registry
                doctors={doctors}
                loadingDoctors={loadingDoctors}
                onRefresh={fetchDoctors}
                onDocuments={goToDocuments}
                onVerification={goToVerification}
                onCreateProfile={() => setSelectedTab(1)}
              />
            </TabPanel>

            <TabPanel>
              <Heading size="md" mb={4}>Create Doctor Profile</Heading>
              <CreateProfile onCreated={() => { fetchDoctors(); setSelectedTab(0) }} />
            </TabPanel>

            <TabPanel>
              <Heading size="md" mb={4}>Documents</Heading>
              <Documents
                doctors={doctors}
                selected={selectedDoctor}
                onSelectDoctor={setSelectedDoctor}
                onGoToRegistry={() => setSelectedTab(0)}
                onGoToVerification={() => setSelectedTab(3)}
                onRefreshDoctors={fetchDoctors}
                refreshingDoctors={loadingDoctors}
              />
            </TabPanel>

            <TabPanel>
              <Heading size="md" mb={4}>Verification</Heading>
              <Verification
                doctors={doctors}
                selected={selectedDoctor}
                onSelectDoctor={setSelectedDoctor}
                onGoToRegistry={() => setSelectedTab(0)}
                onRefreshDoctors={fetchDoctors}
                refreshingDoctors={loadingDoctors}
              />
            </TabPanel>

            {/* TODO: enable in next release
            <TabPanel px={0} pt={4}>
              <DoctorRoster doctors={doctors} />
            </TabPanel>
            */}
          </TabPanels>
        </Tabs>
      </Box>
    </Layout>
  )
}

export default ManageDoctor
